export const TRANSACTION = 'Action.Transaction';
